// Copyright 2025. WebPros International GmbH. All rights reserved.

import {
    api,
    IApiResponse,
} from 'common/api/resources/Response';
import { IComputeResourceRecoveryReadinessStatusResponse } from 'common/api/resources/DisasterRecovery/model';

export const disasterRecovery = {
    computeResource: {
        recoveryReadinessStatus: (id: string) => api.get<IApiResponse<IComputeResourceRecoveryReadinessStatusResponse>>(
            `disaster_recoveries/overview/compute_resources/${id}`
        ),
    },
};
